import store from "@/state/store";

export default [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/pages/account/login"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({
            name: "home",
          });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../views/pages/account/register"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({
            name: "home",
          });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot-password",
    component: () => import("../views/pages/account/forgot-password"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({
            name: "home",
          });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          store.dispatch("auth/logOut");
        } else if (
          process.env.VUE_APP_DEFAULT_AUTH === "fakebackend" ||
          process.env.VUE_APP_DEFAULT_AUTH === "production"
        ) {
          store.dispatch("authfack/logout");
        }
        const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
          route.push("/login")
        );
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute
            ? {
                name: "home",
              }
            : {
                ...routeFrom,
              }
        );
      },
    },
  },
  {
    path: "/",
    name: "home",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/programmes/programme.vue"),
  },
  {
    path: "/program/:programname/:id",
    name: "program",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/programmes/programme_detail.vue"),
  },
  {
    path: "/program/:programname/:id/:subname/:subid/:questioncategory",
    name: "program-detail",
    meta: {
      authRequired: true,
    },
    component: () =>
      import("../views/pages/programmes/programme_sub_detail.vue"),
  },
  {
    path: "/student",
    name: "student",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/student/index"),
  },
  {
    path: "/student/ujian/detail/:id",
    name: "Detail Ujian",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/student/detail_ujian"),
  },
  {
    path: "/student/all/:id",
    name: "List Paket Soal",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/student/list_paket_soal"),
  },
  {
    path: "/profile",
    name: "Profile",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/settings/profile"),
  },
  {
    path: "/student/ujian/:id/start",
    name: "Ujian Start",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/ujian/layout/index"),
  },
  {
    path: "/student/ujian/:id/finish",
    name: "Ujian Finish",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/ujian/layout/finish"),
  },
  {
    path: "/student/ujian/:id/finish-kecermatan",
    name: "Ujian Finish Kecermatan",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/ujian/layout/finish_kecermatan"),
  },
  {
    path: "/scores",
    name: "Scores Student",
    meta: {
      authRequired: true,
    },
    component: () => import("../views/pages/scores/Scores.vue"),
  },
];
